<template>
  <div>
    <div class="control is-horizontal columns">
      <div class="control-label label-create column is-3">
        <label class="label field-required">Name</label>
      </div>
      <div class="control is-grouped column is-9">
        <p class="control is-expanded">
          <input
            v-model="body.name"
            v-validate="'required|max:255'"
            :class="{'is-danger': errors.has('name') }"
            name="name"
            class="input"
            type="text"
            placeholder="Enter name"
          />
          <span
            v-show="errors.has('name')"
            class="help is-danger"
          >{{ errors.first('name') }}</span>
        </p>
      </div>
    </div>

    <div class="control is-horizontal columns">
      <div class="control-label label-create column is-3">
        <label class="label field-required">Description</label>
      </div>
      <div class="control is-grouped column is-9">
        <p class="control is-expanded">
          <input
            v-model="body.description"
            v-validate="'required|max:255'"
            :class="{'is-danger': errors.has('description') }"
            name="description"
            class="input"
            type="text"
            placeholder="Enter description"
          />
          <span
            v-show="errors.has('description')"
            class="help is-danger"
          >{{ errors.first('description') }}</span>
        </p>
      </div>
    </div>
    <div class="control is-horizontal columns">
      <div class="control-label label-create column is-3">
        <label class="label field-required">Type</label>
      </div>
      <div class="control is-grouped column is-9">
        <p class="control is-expanded select is-fullwidth">
          <select
            v-model="type"
            :disabled="isEdit && body.is_flexible"
            name="type"
            @change
          >
            <option
              v-for="item in types"
              :value="item"
            >
{{ item }}
</option>
          </select>
          <span
            v-show="errors.has('type')"
            class="help is-danger"
          >{{ errors.first('type') }}</span>
        </p>
      </div>
    </div>
    <div class="control is-horizontal columns">
      <div class="control-label label-create column is-3">
        <!-- field-required -->
        <label class="label ">Group</label>
      </div>
      <div class="control is-grouped column is-9">
        <p class="control is-expanded select is-fullwidth">
          <select
            v-model="body.group_id"
            @change
          >
            <option
              v-for="item in groups"
              v-if="item.is_active===1"
              :value="item.id"
            >
{{ item.title }}
</option>
          </select>
        </p>
      </div>
    </div>

    <div class="control is-horizontal columns">
      <div class="control-label label-create column is-3">
        <label
          class="label "
          :class="!isEdit? 'field-required':''"
        >Frequency</label>
      </div>
      <div class="control is-grouped column is-9">
        <div class="field has-addons mb-0">
          <div class="control">
            <input
              v-model="body.frequency_interval"
              v-validate="'required|numeric|min_value:1|max_value:12'"
              :disabled="isEdit"
              :class="{'is-danger': errors.has('frequency') }"
              class="input is-expanded"
              name="frequency"
            />
          </div>
          <div class="control">
            <span class="select">
              <select
                v-model="body.frequency"
                :disabled="isEdit"
              >
                <option
                  v-for="t in frequencies"
                  :value="t"
                >{{ t }}</option>
              </select>
            </span>
          </div>
        </div>

        <span
          v-show="errors.has('frequency')"
          class="help is-danger  "
        >{{ errors.first('frequency') }}</span>
</div>
    </div>

    <div class="control is-horizontal columns">
      <div class="control-label label-create column is-3">
        <label
          class="label "
          :class="!isEdit? 'field-required':''"
        > Amount</label>
      </div>
      <div class="control is-grouped column is-9">
        <div class="field has-addons mb-0">
          <div class="control">
            <!-- <input
                v-validate="'required|decimal'"
                :class="{'is-danger': errors.has('amount') }"
                class="input is-expanded"
                type="text"
                placeholder
                name="amount"
                v-model="body.amount"
              /> -->

            <!-- @input="onRawAmountChanged" -->

            <cleave2
              v-model="amount"
              v-validate="'required|decimal:2|min_value:0.01|max_value:999999999999.99'"
              :disabled="isEdit"
              :class="{'is-danger': errors.has('amount') }"
              class="input is-expanded"
              name="amount"
              placeholder
              :options="{ numeral:true,numeralPositiveOnly: true,numeralThousandsGroupStyle: 'thousand' }"
              @input="onRawAmountChanged"
            />
          </div>
          <div class="control">
            <span class="select">
              <select
                v-model="body.currency"
                :disabled="isEdit"
              >
                <option
                  v-for="t in currencies"
                  :value="t.val"
                >{{ t.name }}</option>
              </select>
            </span>
          </div>
</div>
        <span
          v-show="errors.has('amount')"
          class="help is-danger "
        >{{ errors.first('amount') }}</span>
</div>
    </div>

    <!--<div class="control is-horizontal columns">-->
    <!--<div class="control-label label-create column is-3">-->
    <!--<label class="label">Return URL</label>-->
    <!--</div>-->
    <!--<div class="control is-grouped column is-9">-->
    <!--<p class="control is-expanded">-->
    <!--<input v-validate="'max:255'"-->
    <!--:class="{'is-danger': errors.has('return_url') }"-->
    <!--name="return_url" v-model="body.return_url" class="input" type="text"-->
    <!--placeholder="Enter URL">-->
    <!--<span v-show="errors.has('return_url')"-->
    <!--class="help is-danger">{{ errors.first('return_url') }}</span>-->
    <!--</p>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="control is-horizontal columns">-->
    <!--<div class="control-label label-create column is-3">-->
    <!--<label class="label">Cancel URL</label>-->
    <!--</div>-->
    <!--<div class="control is-grouped column is-9">-->
    <!--<p class="control is-expanded">-->
    <!--<input v-validate="'max:255'"-->
    <!--:class="{'is-danger': errors.has('cancel_url') }"-->
    <!--name="cancel_url" v-model="body.cancel_url" class="input" type="text"-->
    <!--placeholder="Enter URL">-->
    <!--<span v-show="errors.has('cancel_url')"-->
    <!--class="help is-danger">{{ errors.first('cancel_url') }}</span>-->
    <!--</p>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="control is-horizontal columns">-->
    <!--<div class="control-label label-create column is-3">-->
    <!--<label class="label">Notify URL</label>-->
    <!--</div>-->
    <!--<div class="control is-grouped column is-9">-->
    <!--<p class="control is-expanded">-->
    <!--<input v-validate="'max:255'"-->
    <!--:class="{'is-danger': errors.has('notify_url') }"-->
    <!--name="notify_url" v-model="body.notify_url" class="input" type="text"-->
    <!--placeholder="Enter URL">-->
    <!--<span v-show="errors.has('notify_url')"-->
    <!--class="help is-danger">{{ errors.first('notify_url') }}</span>-->
    <!--</p>-->
    <!--</div>-->
    <!--</div>-->

    <!--<div class="control is-horizontal columns">-->
    <!--<div style="margin-right: 10px">-->
    <!--<label class="label">Active</label>-->
    <!--</div>-->
    <!--<vb-switch type="success" v-model="body.disable"/>-->
    <!--</div>-->
    <div class="control is-horizontal columns mb-0">
      <div class="control-label label-create column is-3">
        <label class="label">Sort Order</label>
      </div>
      <div class="control is-grouped column is-9">
        <div class="control wd-20">
          <input
            v-model="body.order"
            v-validate="'numeric|min_value:0|max_value:1000'"
            :class="{'is-danger': errors.has('order') }"
            name="order"
            class="input"
            type="text"
          />
        </div>
        <span
          v-show="errors.has('order')"
          class="help is-danger"
        >{{ errors.first('order') }}</span>
        <p class="control">
          <span class="help">
            <small style="font-style: italic;">*The bigger the value, the higher the priority.</small>
          </span>
</p>
      </div>
    </div>
    <!-- <div class="control is-horizontal columns">
        <div class="control-label label-create column is-3">
          <label class="label">Flexi Plan</label>
        </div>
        <div
          class="control is-grouped column is-9 "
          style="display:flex"
        >
          <div
            class="control "
            style="display:flex; align-items:center"
          >
            <vb-switch
              :disabled="body.is_flexible && isEdit"
              type="success"
              v-model="is_flexible"
              :class="{'pointer': body.is_flexible && isEdit}"
            />
          </div>

        </div>
      </div> -->

    <div class="control is-horizontal columns">
      <div class="control-label column is-3">
        <label class="label" />
      </div>
      <div class="control is-grouped column is-9 ">
        <!-- <span
              v-if="this.router.name"
              class="btn-delete"
              @click="onRemove"
            >Delete</span> -->
        <save-button
          :loading="isSaving"
          @click="save"
        />
        <a
          class="button is-link is-light"
          @click="cancel"
        >Cancel</a>

        <button
          v-if="isEdit"
          class="button btn-delete is-link"
          @click="onRemove"
        >
Delete
</button>
</div>
    </div>
  </div>
</template>

<script>
  import { plan_group, plan } from "api";
  import mixin from "components/mixin";
  import fx from "utils/fx";

  export default {
    mixins: [mixin],
    props: {
      data: {
        type: Object,
        default () {
          return {};
        }
      },
      isSaving: Boolean,
      isEdit: Boolean
    },
    data () {
      return {
        body: {
          name: this.data.name ? this.data.name : "",
          amount: this.data.amount ? this.data.amount : 120,
          auto_bill_amount: this.data.auto_bill_amount
            ? this.data.auto_bill_amount
            : "YES",
          cancel_url: this.data.cancel_url
            ? this.data.cancel_url
            : "http://wala.cancel_url",
          currency: this.data.currency ? this.data.currency : "VND",
          cycles: this.data.cycles ? this.data.cycles : 0,
          description: this.data.description ? this.data.description : "",
          frequency: this.data.frequency ? this.data.frequency : "MONTH",
          frequency_interval: this.data.frequency_interval
            ? this.data.frequency_interval
            : 1,
          group_id: this.data.group_id ? this.data.group_id : undefined,
          notify_url: this.data.notify_url
            ? this.data.notify_url
            : "http://wala.notify_url",
          payment_name: this.data.payment_name
            ? this.data.payment_name
            : "payment",
          payment_type: this.data.payment_type
            ? this.data.payment_type
            : "REGULAR",
          return_url: this.data.return_url
            ? this.data.return_url
            : "http://wala.return_url",
          setup_fee: this.data.setup_fee ? this.data.setup_fee : "11.00",
          shipment_fee: this.data.shipment_fee ? this.data.shipment_fee : "10",
          state: this.data.state ? this.data.state : "CREATED",
          // type: this.data.type ? this.data.type : "FIXED",
          order: this.data.order ? this.data.order : 0,
          is_flexible: this.data.is_flexible == 1 ? true : false
        },
        amount: this.data.amount ? this.data.amount : "120",
        is_flexible: this.data.is_flexible == 1 ? true : false,
        type: this.data.is_flexible == 1 ? 'FLEXI' : 'FIXED',
        types: ["FIXED", "FLEXI"],
        frequencies: ["DAY", "WEEK", "MONTH", "YEAR"],
        currencies: [
          // {
          //     name: 'USD',
          //     val: 'USD'
          // },
          {
            name: "VND",
            val: "VND"
          }
        ],
        groups: []
      };
    },
    computed: {
      isUpdatePlan () {
        return this.hasPermission([config.permission.PLANS_UPDATE]);
      },
      isDeletePlan () {
        return this.hasPermission([config.permission.PLANS_DELETE]);
      }
    },
    mounted () {
      this.getGroups();
    },
    created () {
      this.checkRouter();
      // console.log('this.data :>> ', this.data);
    },
    methods: {
      onRawAmountChanged (data) {
        if (!/^[a-zA-Z]+$/.test(data)) {
          this.amount = data.replace(/,/g, "");
        }
      },
      goBack () {
        this.$router.push({ name: 'Plan' });
      },
      onFail () {
        this.$router.push({ name: '403' });
      },
      onRemove () {
        let me = this;
        swal({
          title: "Are you sure?",
          text: "Once deleted, you will not be able to recover this action!",
          icon: "warning",
          buttons: {
            cancel: true,
            confirm: {
              text: "Delete",
              value: true,
              visible: true,
              className: "swal-button--danger ",
              closeModal: true
            }
          },
          allowEnterKey: true,
          focusConfirm: true,
          focusCancel: false,
        })
          .then((willDelete) => {
            if (willDelete) {
              if (!this.isDeletePlan) {
                this.onFail();
              }
              plan.delete(me.$route.params.id).then(res => {
                if (res.data.success === true) {
                  me.openNotificationWithType('success', {
                    title: 'Success',
                    message: ' Delete successfully'
                  });
                  me.goBack();
                }
              }).catch(err => {
                me.openNotificationWithType('danger', {
                  title: 'Error',
                  message: ' Cannot delete this plan!!'
                });

              });
            } else {
            }
          });
      },
      getGroups () {
        let me = this;
        let loader = me.$loading.show();
        let param = {
          sort: 'title',
          order: 'asc'
        };
        plan_group
          .get(param)
          .then(res => {
            if (res.data.success === true) {
              me.groups = res.data.data;
              me.isLoading = false;
              loader.hide();
            }
          })
          .catch(err => {
            loader.hide();
          });
      },
      cancel () {
        this.$emit("cancel");
      },
      save () {
        // this.amount.replace(/,/g, "")
        this.$validator.validateAll().then(result => {
          if (result) {
            this.body.is_flexible = this.type == 'FLEXI' ? 1 : 0;
            this.body.amount = this.amount.replace(/,/g, "");
            this.body.frequency_interval = Number(this.body.frequency_interval);
            this.$emit("save", this.body);
          }
        });
      },
      onChangeType () { },
      checkRouter () {
        // if (this.$route.params.id) {
        //   let me = this;
        //   let loader = me.$loading.show();
        //   plan
        //     .find(this.$route.params.id)
        //     .then(res => {
        //       if (res.data.success === true) {
        //         me.body = res.data.data;
        //         // me.isLoading = false;
        //         loader.hide();
        //       }
        //     })
        //     .catch(err => {
        //       loader.hide();
        //     });
        // }
        if (this.$route.params.body) {
          this.body = this.$route.params.body;
          this.amount = this.$route.params.body ? this.body.amount : "120";
          this.type = this.$route.params.body.is_flexible ? 'FLEXI' : 'FIXED';
          this.is_flexible = this.$route.params.body.is_flexible == 1 ? true : false;
        }
      }
    }
  };
</script>

<style scoped>
</style>
<style >
  .mr-t-10 {
    margin-top: 10px;
  }
  .btn-delete {
    float: right;
    color: red !important;
    cursor: pointer;
  }
  .mt--075 {
    margin-top: -0.75rem;
  }
</style>
<style lang="scss" scoped>
  .mb-0 {
    margin-bottom: 0 !important;
  }
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
</style>
